import { useEffect, useState, useRef } from 'react';
import Loader from '../Layout/Loader';
import { exportToExcel, setTitle, setFocus, BindReportGridWithCheckBox, BindReportGrid, ReverseFormatDate, GetDate, formatDate, } from '../Common/Common';
import { Cookies } from 'react-cookie';
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";
import { getCommonData } from '../Common/CommanServices';
import DatePicker from 'react-datepicker';

const VerifyEmptySorting = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token');
    const navigate = useNavigate();
    const inputrefs = useRef([]);
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [MenuText, setMenuText] = useState("Verify Empty Sorting");
    const [IsVirtaulItemUpdated, setIsVirtaulItemUpdated] = useState(false);
    const SalesPersonName = cookies.get('userName');
    const SalesPersonCode = cookies.get('salesPersonCode');
    const [SalesPerson, setSalesPerson] = useState([]);
   

    const [tableData, setTableData] = useState({});
    
    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    });
   
    const [SaveData, setSaveData] = useState({
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
        InvoiceDateFrom: GetDate(0),
        InvoiceDateTo: GetDate(0), 
        RejectReason:"",
    });
 
    // reset
    const handleClear = () => {
        setSaveData({
            emptySortingID: "0",
            SalesPerson: "",
            InvoiceDateFrom: "",
            InvoiceDateTo: "",
            RejectReason: "",
        });

        setFilterData({
            ...filterData,
            SearchText: "",
            StartValue: "1",
            PageIndex: "1",
        });
        setTableData({ totalRecord: 0, Data: [{}] });
        setIsUpdate(!isUpdate);
    };

    useEffect(() => {
        setTitle('VerifyEmptySorting', setOpen);
        setFocus('txtSalesPerson');
        setTimeout(() => setMenuText(document.title), 500);
    }, []);

    //useEffect(() => {
    //    getItemData();
    //}, [filterData.PageIndex, isUpdate]);

    const handleSubmit = () => {
        setIsLoading(true);
        const loginCodeString = String(LoginUserCode);

        const selectedRows = tableData?.Data?.filter(ele => ele.checkStatus);
        if (!selectedRows || selectedRows.length === 0) {
            setIsLoading(false);
            AlertBox('ERROR', 'Please select at least one row to verify.');
            return;
        }

        const data = {
            Token,
            Type: 'V',
            LoginUserCode: loginCodeString,
            emptySortingID: tableData?.Data?.filter(ele => ele.checkStatus)?.map(item => item['CheckBox'])?.join(',')
        };

        post(`${API_SERVER}/api/Operation/VerifyEmptySorting`, data, (res) => {
            setIsLoading(false);

            if (res.status === 'SUCCESS') {
                AlertBox('SUCCESS', res.message);
                handleClear();
            } else if (res.status === 'EXPIRED') {
                navigate('/Login');
            } else {
                AlertBox('ERROR', res.message, res.focus);
            }
        });
    };
    const handleReject = () => {
        setIsLoading(true);
        const loginCodeString = String(LoginUserCode);

        const selectedRows = tableData?.Data?.filter(ele => ele.checkStatus);
        if (!selectedRows || selectedRows.length === 0) {
            setIsLoading(false);
            AlertBox('ERROR', 'Please select at least one row to Reject.');
            return;
        }

        const data = {
            Token,
            Type: 'Reject',
            LoginUserCode: loginCodeString,
            emptySortingID: tableData?.Data?.filter(ele => ele.checkStatus)?.map(item => item['CheckBox'])?.join(','),
            RejectReason: SaveData.RejectReason,
        };

        post(`${API_SERVER}/api/Operation/VerifyEmptySorting`, data, (res) => {
            setIsLoading(false);

            if (res.status === 'SUCCESS') {
                AlertBox('SUCCESS', res.message);
                handleClear();
            } else if (res.status === 'EXPIRED') {
                navigate('/Login');
            } else {
                AlertBox('ERROR', res.message, res.focus);
            }
        });
    };
    const handleSubmitUnVerify = () => {
        setIsLoading(true);
        const loginCodeString = String(LoginUserCode);

        const selectedRows = tableData?.Data?.filter(ele => ele.checkStatus);
        if (!selectedRows || selectedRows.length === 0) {
            setIsLoading(false);
            AlertBox('ERROR', 'Please select at least one row to Un-verify.');
            return;
        }

        const data = {
            Token,
            Type:'UN',
            LoginUserCode: loginCodeString,
            emptySortingID: tableData?.Data?.filter(ele => ele.checkStatus)?.map(item => item['CheckBox'])?.join(','),
            RejectReason: SaveData.RejectReason,
        };

        post(`${API_SERVER}/api/Operation/VerifyEmptySorting`, data, (res) => {
            setIsLoading(false);

            if (res.status === 'SUCCESS') {
                AlertBox('SUCCESS', res.message);
                handleClear();
            } else if (res.status === 'EXPIRED') {
                navigate('/Login');
            } else {
                AlertBox('ERROR', res.message, res.focus);
            }
        });
    };



    const getItemData = (Type = 'S') => {
        const data = {
            Token,
            Type,
            LoginUserCode: String(LoginUserCode),
            SalesPerson: SaveData.SalesPerson.split(':')[0]?.trim() || "",
            InvoiceDateFrom: SaveData.InvoiceDateFrom,
            InvoiceDateTo: SaveData.InvoiceDateTo,
        };

        setIsLoading(true);
        post(`${API_SERVER}/api/Operation/GetDataForVerifyEmptySorting`, data, (res) => {
            setIsLoading(false);

            if (res.Status === 'SUCCESS') {
                setTableData({
                    ...res,
                    Data: res.Data.map(item => ({
                        ...item,
                        checkStatus: false,
                        EmptySortingID: item.EmptySortingID,
                    })),
                });
            } else if (res.Status === 'EXPIRED') {
                navigate('/Login');
            } else {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData({ totalRecord: 0, Data: [] });
            }
        });
    };

    const handleChange1 = () => {
        getItemData("S");
    };

    const handleCheck = (checked, item, index) => {
        setTableData(prev => {
            const newData = prev.Data.map((row, i) =>
                i === index ? { ...row, checkStatus: checked } : row
            );
            return { ...prev, Data: newData };
        });
    };

    const handleAllchange = (e) => {
        const { checked } = e.target;
        setTableData(prev => {
            const newData = prev.Data.map(row => ({ ...row, checkStatus: checked }));
            return { ...prev, Data: newData };
        });
    };

    const getSalesPerson = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetSalesPersonANDWarehouseName",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPerson(salesPersonData);
            } else {
                setSalesPerson([]);
            }
        });
    };
    let SalesPersonArr = []
    for (let i = 0; i < SalesPerson.length; i++) {
        let mydata = SalesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };
    //Handle search
    const handleSearch = () => {
        getItemData('S');
    };

    //const handleDownloadExcel = () => {
    //    if (tableData.Data && tableData.Data.length > 0) {
    //        exportToExcel(tableData.Data, 'ActualVirtualItemMapping');
    //    } else {
    //        AlertBox('ERROR', 'No data to export');
    //    }
    //};

    //useEffect(() => {
    //    if (IsVirtaulItemUpdated) {
    //        getItemData("S", SaveData.VirtualItem)
    //        setIsVirtaulItemUpdated(false)
    //    }
    //}, [IsVirtaulItemUpdated])

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>

                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                inputrefs={inputrefs}
                                                //disabled={SalesPersonCode ? true : false}
                                                label='WareHouse / Sales Person'
                                                placeholder="Sales Person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getSalesPerson()}
                                                inputValue={SaveData.SalesPerson || ''}
                                                onInputChange={(event, newValue) => {
                                                    setSaveData(prev => ({ ...prev, SalesPerson: newValue }));
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtInvoiceDateFrom") };
                                                }}
                                            />


                                        </div>
                                      
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">From Date </label>
                                            <DatePicker selected={ReverseFormatDate(SaveData.InvoiceDateFrom) || null}
                                            
                                                id='txtInvoiceDateFrom'
                                                className="form-control"
                                                placeholderText='Select From Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => {
                                                    setSaveData({ ...SaveData, InvoiceDateFrom: formatDate(date) })
                                                }}
                                                maxDate={new Date()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtInvoiceDateTo');
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">To Date </label>
                                            <DatePicker selected={ReverseFormatDate(SaveData.InvoiceDateTo) || null}
                                                id='txtInvoiceDateTo'
                                                className="form-control"
                                                placeholderText='Select To Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => {
                                                    setSaveData({ ...SaveData, InvoiceDateTo: formatDate(date) })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtInvoiceDateTo')
                                                    };
                                                }}
                                                maxDate={new Date()}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Reject Reason<span className="Required">*</span></label>
                                            <input
                                                id='txtReason'
                                                type="text"
                                                maxLength="100"
                                                className="form-control"
                                                placeholder='Enter Reject Reason'
                                                value={SaveData.RejectReason}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, RejectReason: e.target.value.toLocaleUpperCase()
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            <button
                                                className="button search-btn"
                                                onClick={handleSearch}
                                            >
                                                <i className="bi bi-search" /> Search
                                            </button>
                                            {isLoading ? (
                                                <button className="button save-btn btn-disable" disabled>
                                                    Please wait...
                                                </button>
                                            ) : (
                                                <button className="button save-btn" onClick={handleSubmit}>
                                                    <i className="bi bi-check-lg" /> Verify
                                                </button>

                                            )}
                                           
                                            <button className="button reset-btn" onClick={handleReject}>
                                                <i className="bi bi-x-lg" /> Reject / Reverse
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <BindReportGrid
                tableData={tableData}
                setFilterData={setFilterData}
                filterData={filterData}
                handleChange1={handleChange1}
                currentPageNo={currentPageNo}
                handleCheckboxChange={handleCheck}
                handleAllchange={handleAllchange}
            />
            {isLoading && <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' />}
        </main>
    );
};

export default VerifyEmptySorting;
